// Import necessary modules and hooks from React Router and React
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "../../../contexts/AuthContext";
import { usePageContentContext } from "../../../contexts/PageContentProvider";

// Define a component called PublicRoute which receives a prop called redirectPath with a default value of '/home'
export const PublicRoute = ({ redirectPath = '/map' }) => {
    // Use the useAuthContext() hook to get the user from the authentication context
    const { user, zones } = useAuthContext();
    const { handlePagePathChange } = usePageContentContext();

    const [token, setToken] = useState(null);

    // Define an effect that updates the token state when the user changes
    useEffect(() => {
        setToken(localStorage.getItem('mico_token'));
    }, [user]); // Dependency of the effect, this effect will be triggered when the user changes

    // If there is a token, log the redirection path and navigate to the specified route
    if (user && token) {
        const pathToRedirect = zones && zones.length > 0 ? '/' + zones[0] : redirectPath
        handlePagePathChange(pathToRedirect);
        return <Navigate to={pathToRedirect} replace />;
    }

    // If there's no token, render the Outlet component which renders nested routes
    return <Outlet />
}
